import { render, staticRenderFns } from "./icon-upload.vue?vue&type=template&id=086b9a62&scoped=true&"
import script from "./icon-upload.vue?vue&type=script&lang=js&"
export * from "./icon-upload.vue?vue&type=script&lang=js&"
import style0 from "./icon-upload.vue?vue&type=style&index=0&id=086b9a62&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086b9a62",
  null
  
)

export default component.exports